export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6904.0f3d590c.jpg";